/**
 * Fisher-Yates (Knuth) shuffle — in-place on a copy.
 * Returns a new shuffled array; does not mutate the original.
 */
export function shuffleArray<T>(array: T[]): T[] {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

/**
 * Shuffles options and returns { shuffledOptions, shuffledCorrectIndex }.
 * Keeps the correct answer tracked correctly through the shuffle.
 */
export function shuffleOptionsWithCorrect(
  options: string[],
  correctIndex: number
): { shuffledOptions: string[]; shuffledCorrectIndex: number } {
  const correctAnswer = options[correctIndex];
  const indexed = options.map((opt, i) => ({ opt, originalIndex: i }));
  const shuffled = shuffleArray(indexed);
  const shuffledOptions = shuffled.map(s => s.opt);
  const shuffledCorrectIndex = shuffled.findIndex(s => s.originalIndex === correctIndex);
  return { shuffledOptions, shuffledCorrectIndex };
}
